<template>
  <Layout>
    <template #content>
      <div class="mainContent fish">
        <pageHead device="desktop" page="fish" :title="Title" :description="$t('store.egame_description')"/>
        <div class="pageTitle"></div>
        <eGame :categoryId="CategoryId" :title="Title"/>
      </div>
    </template>
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import eGame from "~/pages/game/egame/egame.vue";
  export default {
    components: {
      Layout,
      pageHead,
      eGame,
    },
    data() {
      return {
        CategoryId: 6
      };
    },
    methods: {
      ...mapActions("game", ["getGameList"]),
      ...mapMutations("game", ["setProductId", "setTableSettingCurrent",]),
    },
    mounted: function () {
      this.setProductId('999');
      this.setTableSettingCurrent(1);
      this.$nextTick(() => this.getGameList());
    },
    computed: {
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        if (this.HasX)
          return '捕魚機、拉霸機' + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
        else
          return this.$t("store.game_fish") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      ...mapGetters(["WebSeoName", "ShowPageWebSeoName"])
    },
  };
</script>

<style scoped></style>
